import { DRNotificationResponse } from "../../../Components/Notifications/notificationsTypes";

export type DRFileType = "Lender" | "LLC" | "New Home";

export type DRListItem = {
    MsgID: number;
    MsgType: string;
    OtherSideType: DRFileType;
    AvailableDate: string;
    MatterNumber: string;
    LawyerID: string;
    ClosingDate: string;
    ClientName: string;
    Status: number;
    ProjectName: string;
}

export const DRMessageStatuses = [
    "Pending Acceptance",
    "Active",
    "Completed",
    "Cancellation Requested",
    "Cancelled"
] as const;
  
type DRMessageStatus = typeof DRMessageStatuses[number];

export function otherDateText(d: Date, diff: number) {
    d.setDate(d.getDate() - diff);
    var formattedDate = d.toISOString().slice(0, 19).replace("T", " ");
    return formattedDate;
}

export function DRReponse2ListItem(entry: DRNotificationResponse): DRListItem {
    const item: DRListItem = {
        MsgID: entry.MsgID,
        MsgType: entry.MsgType,
        AvailableDate: entry.AvailableDate,
        MatterNumber: String(entry.MatterID),
        LawyerID: entry.LSUCID,
        ClosingDate: entry.ClosingDate,
        ClientName: entry.Description,
        Status: entry.ReadStatus,
        ProjectName: entry.ProjectName,
        OtherSideType: "New Home"
    }
    if (entry.MsgType === '1'){
        item.ProjectName = entry.BankName;
    } else if (entry.MsgType === '10') {
        item.ProjectName = entry.SenderName;
    }
    if (entry.MsgType === '1'){
        item.OtherSideType = "Lender"
    } else if (entry.MsgType === '10') {
        item.OtherSideType = "LLC"
    }
    return item;
}

export function getDRMessageStatus(item: DRListItem): DRMessageStatus {
    const readStatus = item.Status;
    const transactionId = item.MatterNumber;
    if (readStatus == 1) return "Active";
    if ((item.MsgType === '10' && transactionId && transactionId > "" && readStatus == 2) ||
        (item.MsgType !== '10' && readStatus == 3)) {
        return "Completed";
    }
    if (item.MsgType === '10' && transactionId && transactionId > "" && readStatus == 3) {
        return "Cancellation Requested"; // only LLC
    }
    if (item.MsgType === '10' && transactionId && transactionId > "" && readStatus == 4) {
        return "Cancelled"; // only LLC
    }
    if (!readStatus || readStatus == 0) {
        return "Pending Acceptance";
    }
    return "Active";
}